var map = {
	"./trumbowyg.cleanpaste": [
		55122,
		9099
	],
	"./trumbowyg.cleanpaste.js": [
		55122,
		9099
	],
	"./trumbowyg.fontfamily": [
		94104,
		2436
	],
	"./trumbowyg.fontfamily.js": [
		94104,
		2436
	],
	"./trumbowyg.fontsize": [
		94130,
		8301
	],
	"./trumbowyg.fontsize.js": [
		94130,
		8301
	],
	"./trumbowyg.image": [
		435,
		8181
	],
	"./trumbowyg.image.js": [
		435,
		8181
	],
	"./trumbowyg.lineheight": [
		76467,
		1581
	],
	"./trumbowyg.lineheight.js": [
		76467,
		1581
	],
	"./trumbowyg.moveText": [
		343,
		1142
	],
	"./trumbowyg.moveText.js": [
		343,
		1142
	],
	"./trumbowyg.pasteimage": [
		15760,
		2410
	],
	"./trumbowyg.pasteimage.js": [
		15760,
		2410
	],
	"./trumbowyg.quote": [
		24935,
		5932
	],
	"./trumbowyg.quote.js": [
		24935,
		5932
	],
	"./trumbowyg.replaceEmptyHrefLinks": [
		97009,
		4802
	],
	"./trumbowyg.replaceEmptyHrefLinks.js": [
		97009,
		4802
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5036;
module.exports = webpackAsyncContext;